const Toolbar = () => <p>customer Tool bar</p>

export default Toolbar
